import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import UserRole from '../../../shared/AuthRoles';
import { useRefreshMutation } from '../../../app/Slices/SevenDayApiSlice';

const RequireAuth = () => {
    const [loadingToken, setLoadingToken] = useState(true);
    const loggedInUser = UserRole();
    const [refresh] = useRefreshMutation();
    const location = useLocation();

    useEffect(() => {
        const loadAccessToken = async () => {
            try {
                await refresh({});
            } finally {
                setLoadingToken(false);
            }
        };
        loadAccessToken();
    }, [refresh]);

    if (loadingToken) return <></>;

    if (!loggedInUser) {
        return <Navigate to='/login' replace state={{ from: location }} />;
    }

    return <Outlet />;
};

export default RequireAuth;
